export default __webpack_public_path__ + "info-small.7eb5205d30113c8a.svg";